import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=75472c38&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=75472c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75472c38",
  null
  
)

export default component.exports